//=====================================================
//　診療終了通知チェックボックス
//=====================================================

import { useContext } from "react";
import { InputCheckBase } from "./InputCheckBase";
import { InputTag } from '../utils/ConstCommon';
import { LblInputHelper } from './LblInputHelper';
import { ConstMsg } from "../utils/ConstMsg";
import { CtxClinicSystemInfo } from "../utils/Contexts";

const FORM_TITLE = "診療終了通知";
const chkMail = "finish-notice-mail";
const chkSms = "finish-notice-sms";

export function ChkEndNotice(){

    const ccsi = useContext(CtxClinicSystemInfo);

    return (
        <>
            <div className="patient-data input-box">
                <div className="input-title finish-notice">
                    <LblInputHelper title={FORM_TITLE} tag={InputTag.Optional} message={ConstMsg.IG0210002} />
                </div>
                <div className="input-box-checkbox">
                    <InputCheckBase name={chkMail} title="メールで通知する" value="1" className="agree-check" />
                </div>
                { ccsi.data.usability.smsNotification &&
                    <div className="input-box-checkbox">
                        <InputCheckBase name={chkSms} title="SMSで通知する" value="1" className="agree-check" />
                    </div>
                }
            </div>
        </>
    )

}